module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./RoleAddView.js"));
	}, "roleAddView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=roleAddView!./src/pages/RoleMgmt/RoleAdd/RoleAddView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=roleAddView!./src/pages/RoleMgmt/RoleAdd/RoleAddView.js
// module chunks = 43